@if (title) {
  <h3 data-testid="title" tuiTitle="m">
    {{ title }}
  </h3>
}
<div class="mx-1 grid gap-3 md:grid-cols-2">
  <ng-content />
</div>
